// @flow
import React, {Component} from 'react';
import type {Node} from 'react';
import logger from '../../utils/clientLogger';
import FallbackComponent from './FallbackComponent';

type Props = {
    children: Node,
    fallbackComponent: Node
};

type State = {
    hasError: boolean
};

export default class ErrorBoundary extends Component<Props, State> {
    static defaultProps = {
        fallbackComponent: <FallbackComponent />
    };

    constructor() {
        super();
        this.state = {hasError: false};
    }

    componentWillReceiveProps = () => {
        /* We want to clear this state everytime ErrorBoundary re-renders */
        this.setState({hasError: false});
    };

    componentDidCatch(error: Error, info: Object) {
        this.setState({hasError: true});
        logger.captureException(error, {extra: info});
    }
    render() {
        const {children, fallbackComponent} = this.props;
        const {hasError} = this.state;

        if (hasError) {
            return fallbackComponent;
        }

        return children;
    }
}
